import React, { Component } from "react";
import classnames from "classnames";
import { observer } from "mobx-react";

import { toLegacyTagsets } from "@formant/core/common/toLegacyTagsets";
import { IFilter } from "@formant/core/model/IFilter";
import { Fader } from "@formant/ui/component/common/Fader";
import { HStack } from "@formant/ui/component/common/HStack";

import { track } from "../../analytics";
import { observeStore } from "../../stores";
import { EditFilter } from "./EditFilter";
import * as styles from "./FilterDrawer.scss";
import { Switch } from "./Switch";

export interface IFilterDrawerProps {
    visible: boolean;
    filter: IFilter;
    context?: IFilter;
    hideDevices?: boolean;
    onChangeFilter: (filter: IFilter) => void;
}

@observer
export class FilterDrawer extends Component<IFilterDrawerProps> {
    public componentDidUpdate(previous: IFilterDrawerProps) {
        const { props } = this;
        if (!previous.visible && props.visible) {
            track("Filter: Open");
        }
        if (previous.visible && !props.visible) {
            track("Filter: Close");
        }
        const names = props.filter.names || [];
        const oldNames = previous.filter.names || [];
        if (names.find(_ => !oldNames.includes(_))) {
            track("Filter: Add Name");
        }
        if (oldNames.find(_ => !names.includes(_))) {
            track("Filter: Remove Name");
        }
        const types = props.filter.types || [];
        const oldTypes = previous.filter.types || [];
        if (types.find(_ => !oldTypes.includes(_))) {
            track("Filter: Add Type");
        }
        if (oldTypes.find(_ => !types.includes(_))) {
            track("Filter: Remove Type");
        }
        const deviceIds = props.filter.deviceIds || [];
        const oldDeviceIds = previous.filter.deviceIds || [];
        if (deviceIds.find(_ => !oldDeviceIds.includes(_))) {
            track("Filter: Add Device");
        }
        if (oldDeviceIds.find(_ => !deviceIds.includes(_))) {
            track("Filter: Remove Device");
        }
        const keys = [
            ...new Set([
                ...Object.keys(props.filter.tags || {}),
                ...Object.keys(previous.filter.tags || {}),
            ]),
        ];
        for (const key of keys) {
            const values =
                (toLegacyTagsets(props.filter.tags) || {})[key] || [];
            const oldValues =
                (toLegacyTagsets(previous.filter.tags) || {})[key] || [];
            if (values.find(_ => !oldValues.includes(_))) {
                track("Filter: Add Tag");
            }
            if (oldValues.find(_ => !values.includes(_))) {
                track("Filter: Remove Tag");
            }
        }
    }

    public render() {
        const { visible, filter, context, hideDevices, onChangeFilter } =
            this.props;
        const { hideInactiveStreams, fullscreen } = observeStore;

        if (fullscreen) {
            return false;
        }

        return (
            <div
                className={classnames(
                    styles["filter-drawer"],
                    visible && styles.visible,
                )}
            >
                <Fader visible={visible}>
                    <HStack hAlign="stretch" vAlign="top">
                        {!hideDevices ? (
                            <HStack
                                hAlign="start"
                                vAlign="center"
                                className={styles["hide-inactive"]}
                            >
                                <Switch
                                    label="Hide inactive streams"
                                    state={hideInactiveStreams}
                                    onChange={this.onToggleHideInactive}
                                    small={true}
                                />
                            </HStack>
                        ) : null}

                        <EditFilter
                            value={filter}
                            context={context}
                            hideDevices={hideDevices}
                            onChange={onChangeFilter}
                        />
                    </HStack>
                </Fader>
            </div>
        );
    }

    private onToggleHideInactive = (state: boolean) => {
        observeStore.hideInactiveStreams = state;
    };
}
